module.exports = __webpack_public_path__ + "img/ic_16_next.2f912b8f.svg";